import styled from "styled-components";
import { colors } from "../../../../../consts";
import { Paragraph2, WrapperContainer } from "../../../../../components";
import { LanguageSelectorWrapper } from "../../../../../templates/LanguageSelectorTemplate/styled";

export const Title = styled(Paragraph2)`
  font-weight: 700;
  padding: 0 24px;
`;

export const MainWrapper = styled(WrapperContainer)`
  width: 100%;
  height: 100%;
  margin-top: 8px;

  border-top: 1px solid;
  border-color: ${colors.RAISIN_10};

  padding-left: 24px;

  ${LanguageSelectorWrapper} {
    padding-top: 16px;
  }

  > div {
    display: grid;
    grid-template-columns: 219px calc(100% - 235px);
  }
`;

export const ContentWrapper = styled(WrapperContainer)`
  width: calc(100% - 3px);
  max-height: 100vh;
  height: 100%;
  overflow-y: auto;

  border-left: 1px solid;
  border-color: ${colors.RAISIN_10};

  @media screen and (max-width: 1380px) {
    max-height: calc(100vh - 440px);
  }
`;
